import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import { Avatar } from '../avatar';
import Theme from '../../styles/theme';
import Button from '../buttons/button';
import AppText from '../typography/app_text';
import { AppIcon } from '../icons';
import { Box, Flex } from '../layout';
export const ProfileBlub = ({ avatarUrl, email, name, workspace, canSwitchWorkspace = false, onEditProfile, onLogOut = () => { }, centralLoginUrl, statusColor, statusText, onSwitchWorkspaces = () => { }, onOpenDeviceSettings = () => { }, closeBlub = () => { }, onOpenSystemNotifications = () => { }, }) => {
    return (_jsxs(ProfileBlubWrapper, { workspaceImageUrl: workspace?.imageUrl, children: [_jsxs(Flex, { alignItems: "center", style: {
                    paddingLeft: '16px',
                    marginBottom: '12px',
                }, children: [_jsx(Avatar, { src: avatarUrl, displayName: name, size: "small" }), _jsxs(Box, { marginLeft: "12px", children: [_jsx(AppText, { as: "h3", semibold: true, children: name }), _jsx(AppText, { style: { fontSize: '14px' }, children: email }), statusColor && statusText && (_jsxs(StatusContainer, { children: [_jsx(StatusIndicator, { color: statusColor, alignItems: "center", justifyContent: "center", borderRadius: 50 }), _jsx(AppText, { style: { color: Theme.colors.grey40, fontSize: '14px' }, children: statusText })] }))] })] }), workspace && (_jsxs("div", { className: "workspace__current-space-wrapper", children: [_jsxs(Flex, { justifyContent: "space-between", alignItems: "center", children: [_jsxs(Flex, { children: [canSwitchWorkspace ? (_jsx(AppIcon, { className: "workspace__done-icon", name: 'DoneIcon', color: Theme.colors.azure })) : (_jsx("span", {})), _jsxs("div", { className: "workspace__text", children: [_jsx(AppText, { as: "h4", color: "medium", style: { fontSize: '14px' }, semibold: true, children: "WORKSPACE" }), _jsx(AppText, { as: "h3", semibold: true, children: workspace.name }), _jsx(AppText, { style: { fontSize: '14px' }, as: 'p', children: workspace.url })] })] }), _jsx("div", { className: "workspace__image", children: !workspace.imageUrl && (_jsx(AppText, { as: "p", bold: true, size: "medium", color: "light", children: workspace.name.charAt(0) })) })] }), canSwitchWorkspace && centralLoginUrl && (_jsx(Button, { onClick: async () => {
                            await onSwitchWorkspaces();
                            window.location.assign(centralLoginUrl);
                        }, variant: "inline", style: {
                            marginTop: '16px',
                            marginBottom: '24px',
                        }, children: "Switch to another workspace" }))] })), onEditProfile && (_jsx(ProfileButton, { onClick: onEditProfile, "data-testid": "profile-popout-edit-profile", closeBlub: closeBlub, children: _jsx(AppText, { children: "Edit Profile" }) })), _jsx(ProfileButton, { onClick: onOpenDeviceSettings, "data-testid": "profile-popout-device-settings", closeBlub: closeBlub, children: _jsx(AppText, { children: "Device Settings" }) }), _jsx(ProfileButton, { onClick: onOpenSystemNotifications, "data-testid": "profile-popout-system-notifications", closeBlub: closeBlub, children: _jsx(AppText, { children: "System Notifications" }) }), _jsx(ProfileButton, { onClick: onLogOut, "data-testid": "profile-popout-log-out-user", closeBlub: closeBlub, children: _jsx(AppText, { children: "Log Out" }) })] }));
};
const StatusContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
});
const StatusIndicator = styled(Flex)(({ color }) => ({
    zIndex: 1,
    height: '10px',
    width: '10px',
    background: color,
    marginRight: '8px',
}));
const ProfileBlubWrapper = styled.div(({ theme, workspaceImageUrl }) => ({
    position: 'relative',
    width: '360px',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: `24px`,
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadow.xlarge,
    borderRadius: '10px',
    wordBreak: 'break-word',
    '.workspace__current-space-wrapper': {
        width: '100%',
        borderTop: `1px solid ${theme.colors.grey10}`,
        paddingTop: '16px',
        paddingLeft: '16px',
        paddingRight: '16px',
    },
    '.workspace__done-icon': {
        alignSelf: 'end',
        marginRight: '16px',
        marginBottom: '16px',
    },
    '.workspace__image': {
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundImage: `url(${workspaceImageUrl})`,
        backgroundColor: workspaceImageUrl ? theme.colors.white : theme.colors.darkGradientTop,
        height: '48px',
        width: '48px',
        border: `1px solid ${theme.colors.grey10}`,
        borderRadius: '10px',
        marginLeft: theme.spacing.s,
        marginRight: theme.spacing.s,
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '.workspace__text': {
        '>*': {
            overflowWrap: 'anywhere',
            overflow: 'hidden',
            display: '-webkit-box',
        },
        '>*:nth-of-type(1)': {
            marginBottom: '2px',
        },
    },
}));
const StyledProfileButton = styled('button')(({ theme }) => ({
    border: 'none',
    borderTop: `1px solid ${theme.colors.grey10}`,
    padding: '16px',
    textAlign: 'left',
    backgroundColor: 'white',
    cursor: 'pointer',
    ':hover': {
        backgroundColor: theme.colors.blue05,
    },
    ':last-of-type': {
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px',
    },
}));
const ProfileButton = ({ closeBlub, onClick, ...props }) => {
    const handleClick = (e) => {
        closeBlub();
        onClick?.(e);
    };
    return _jsx(StyledProfileButton, { onClick: handleClick, ...props });
};
//# sourceMappingURL=profile_blub.js.map